import React from 'react';
import { useSelector } from 'react-redux';

import { isReactionsButtonEnabled, shouldDisplayReactionsButtons } from '../../functions.web';

import ReactionsMenuButton from './ReactionsMenuButton';

const ReactionsContainerButton = (props: IProps) => {
    const reactionsButtonEnabled = useSelector(isReactionsButtonEnabled);
    const _shouldDisplayReactionsButtons = useSelector(shouldDisplayReactionsButtons);
    const isNarrowLayout = useSelector(state => state['features/base/responsive-ui'].isNarrowLayout);
    const showReactionsAsPartOfRaiseHand
        = _shouldDisplayReactionsButtons && !reactionsButtonEnabled && !isNarrowLayout;
    const _conferenceView = useSelector(state => state['features/base/conference'].conferenceView);

    return (<ReactionsMenuButton
        { ...props }
        conferenceView = { _conferenceView }
        showRaiseHand = { false }
        showReactionsAsPartOfRaiseHand = { showReactionsAsPartOfRaiseHand } />);
};

export default ReactionsContainerButton;
